export default __webpack_public_path__ + "static/media/bg3.028d64a5.jpg";